import { render, staticRenderFns } from "./ContentChainView.vue?vue&type=template&id=29598c66&scoped=true&"
import script from "./ContentChainView.vue?vue&type=script&lang=js&"
export * from "./ContentChainView.vue?vue&type=script&lang=js&"
import style0 from "./ContentChainView.vue?vue&type=style&index=0&id=29598c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29598c66",
  null
  
)

export default component.exports